export default __webpack_public_path__ + "static/media/no money.e265b622.png";